/**
 * Inject the detected fonts in the SVG.
 */
export async function injectDetectedFonts(svg: SVGSVGElement) {
    const styleFonts = svg.querySelector('.style-fonts');
    if (!styleFonts) {
        return;
    }

    const fontFamilies = collectFontFamilies(svg);
    const fontNames = resolveFonts(fontFamilies);

    if (fontNames.length === 0) {
        return;
    }

    const { getFontFace } = await import('./font-face.lazy');

    styleFonts.innerHTML = fontNames.map((fontName) => getFontFace(fontName)).join('\n');
}

/**
 * Resolve all fonts to their real name (Virgil or Excalifont).
 */
function resolveFonts(families: Set<string>): Array<'Virgil' | 'Excalifont'> {
    const fonts: Array<'Virgil' | 'Excalifont'> = [];

    if (families.has('virgil')) {
        fonts.push('Virgil');
    }

    if (families.has('excalifont')) {
        fonts.push('Excalifont');
    }

    return fonts;
}

/**
 * Collect all font families used in the SVG.
 */
function collectFontFamilies(svg: SVGSVGElement): Set<string> {
    const families = new Set<string>();

    svg.querySelectorAll('text').forEach((node) => {
        const attr = node.getAttribute('font-family');
        if (attr) {
            families.add(normalizeFontFamily(attr));
        }

        const computed = node.style.fontFamily;
        if (computed) {
            families.add(normalizeFontFamily(computed));
        }
    });

    return families;
}

/**
 * Normalize the font family.
 */
function normalizeFontFamily(fontFamily: string): string {
    return fontFamily
        .split(',')[0]
        .trim()
        .replace(/^["']|["']$/g, '')
        .toLowerCase();
}
